import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {withRouter} from 'react-router-dom'
import {Modal} from 'antd'

@withRouter
@inject('store') @observer
class Sample extends Component {
  handleOk = async () => {
    const {algo} = this.props.store
    await algo.runBacktest()
    const {id} = algo.single.data.backtest
    this.props.history.push(`/backtest/algo/${id}`)
  }
  render() {
    return(
      <Modal
        visible={this.props.visible}
        onOk={this.handleOk}
        onCancel={this.props.close}
      >
        <h3>Sample algos can&apos;t be edited. To run the backtest click on Save As to create a new Algo</h3>
      </Modal>
    )
  }
}

export default Sample
